import { Code } from '@do/walrus';
import DOMPurify from 'dompurify';
import _get from 'lodash/get';
import React from 'react';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { HtmlField } from '../../styles/components';

const DEFAULT_LANGUAGE = 'shell';

function transform(node, index) {
  // if we have <a> tags, then automatically open then in a new tab
  if (node.type === 'tag' && node.name === 'a' && node.attribs) {
    node.attribs.target = '_blank';
    node.attribs.rel = 'noopener noreferrer';

    if (typeof node.attribs.href === 'string') {
      node.attribs.href = node.attribs.href.replace(/\\"/g, '');
    }

    return convertNodeToElement(node, index, transform);
  }

  // if we have <pre><code>...</code></pre> or <pre>...<pre> (Prismic's version of preformatted text)
  // then let's render the <Code> Component
  if (node.type === 'tag' && node.name === 'pre') {
    const codeNode = node.children[0];
    // grab snippet text
    let text = codeNode.data;
    if (
      node.children.length &&
      node.children[0].type === 'tag' &&
      node.children[0].name === 'code'
    ) {
      text = codeNode.children[0].data;
    }

    // get language from class attribute
    // if no language is set then use default
    const cssClass = _get(codeNode, 'attribs.class');
    const parts = cssClass ? cssClass.split('language-') : [DEFAULT_LANGUAGE];
    const language = parts[parts.length - 1];

    return (
      <Code key={`${node.name}-${index}`} language={language} noToolbar={true}>
        {text}
      </Code>
    );
  }
}

const FormatCodeInHtml: React.FC<{ htmlStr: string }> = ({ htmlStr }) => (
  <HtmlField>
    {ReactHtmlParser(DOMPurify.sanitize(htmlStr), { transform })}
  </HtmlField>
);

export default FormatCodeInHtml;
